//引入上边封装的axios文件
import request from "@/request";
import qs from "qs";  

// 供应商获取商品列表
export const get_goods = (data) => {
    return request({
        url: "/supplier/supplierGoods/page?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 供应商获取商品详情
export const goods_detail = (id) => {
    return request({
        url: "/supplier/supplierGoods/detail/"+id,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 供应商编辑商品
export const goods_edit = (data) => {
    return request({
        url: "/supplier/supplierGoods/update",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 新增商品
export const add_goods = (data) => {
    return request({
        url: "/supplier/supplierGoods/add",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 获取所有商品分类
export const get_category = () => {
    return request({
        url: "/common/baseCategory/trees",
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 商品分类id换取商品参数规格等
export const get_goods_specs = (baseCategoryId) => {
    return request({
        url: "/supplier/supplierGoods/getSpecs?baseCategoryId="+baseCategoryId,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 获取运费模版
export const get_yunfei = () => {
    return request({
        url: "/supplier/freightTemplate/list",
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 获取自定义规格
export const getCustomSpecs = (type) => {
    return request({
        url: `/supplier/baseSpecsProps/getCustomSpecs/${type}`,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
// 新增属性值
export const addSpecsData = (data) => {
    return request({
        url: "/supplier/baseSpecsProps/addSpecValues",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 删除属性值
export const deletSpecsData = (data) => {
    return request({
        url: "/supplier/baseSpecsProps/deleteSpecValues",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 新增属性名称
export const addSpecsName = (data) => {
    return request({
        url: "/supplier/baseSpecsProps/addSpec",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 商品上下架
export const online_goods = (data) => {
    return request({
        url: "/supplier/supplierGoods/shelves",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 商品上下架
export const audit_goods = (data) => {
    return request({
        url: "/supplier/supplierGoods/sendAudit",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 商品删除 ----->放到回收站
export const delete_goods_recycle = (data) => {
    return request({
        url: "/supplier/supplierGoods/updateDeleteBatch",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 商品删除 ----->删除回收站的商品
export const delete_goods = (data) => {
    return request({
        url: "/supplier/supplierGoods/deleteBatch",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 商品还原
export const goods_origin = (data) => {
    return request({
        url: "/supplier/supplierGoods/restore",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
// 根据标品id获取商品信息
export const get_base_goods = (base_goods_id) => {
    return request({
        url: "/supplier/baseGoods/detailForSpec/"+base_goods_id,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        }
    });
};
// 根据分类id获取标品
export const get_basgoods = (category_id) => {
    return request({
        url: "/supplier/baseGoods/list/"+category_id,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        }
    });
};
// 上传图片
export const upload_image = (data) => {
    return request({
        url: "/common/upload",
        method: "POST",
        headers:{
            "content-type": "multipart/form-data"
        },
        data
    });
};

